import { boxPropExclusions } from '../../Box/props.js';

var createStyledOptions = function createStyledOptions(skippedProps) {
  return {
    shouldForwardProp: function shouldForwardProp(prop) {
      return !prop.startsWith("$") && !skippedProps.has(prop);
    }
  };
};
var boxStyledOptions = createStyledOptions(boxPropExclusions);

export { boxStyledOptions };
